import React, {useState, useEffect} from 'react'
// Styles
import './cdph.style.css'
import { NhealthAction } from '../../_actions/action.api'
import { Base_API } from '../../_actions/matcher'
import { AddOn } from '../../_actions/add-on'
import moment from 'moment-timezone'
import { DecryptedOBJ, EncryptedText } from '../../utils/Encryption'
import lineConfig from '../../_actions/authLine/lineConfig'
import useLineLogin from '../../_actions/authLine/lineLogin'
import { authenAll } from '../../_actions/sso.authen'


function CardPointHistory() {
    const [dataMockup, setDataMockup] = useState([
        {
            id: 1,
            date: '12/06/2564 12:00',
            title: 'แลกคะแนนแพ็คเกจตรวจสุขภาพ',
            point: -90
        },
        {
            id: 2,
            date: '12/06/2564 12:00',
            title: 'โปรโมชั่นพิเศษ ซื้อ 2 แพ็คเกจ',
            point: +300
        },
        {
            id: 3,
            date: '12/06/2564 12:00',
            title: 'สั่งซื้อเครื่องเอกซเรย์ วินิจฉัยทางการแพทย์',
            point: +50
        },
        {
            id: 4,
            date: '12/06/2564 12:00',
            title: 'แลกคะแนนแพ็คเกจตรวจสุขภาพ',
            point: -100
        }
    ]);
    const [loading, setLoading] = useState(true);
    const [pointList, setPointList] = useState([]);

    useEffect(() => {
        dataInit();
    }, [])

    const dataInit = async() => {
        // let memberInfoInit = await getMemberInfoInit(); // ไม่ได้ใช้แล้ว
        // await useLineLogin(lineConfig.point_history);
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)

        await authenAll(lineConfig.point_history)
        let memberCode = await checkUserInit();
        let getCardID = await getCardInit(memberCode);
        await getLogPoint(getCardID);
        handleLoader('inactive');
    }

    const getLogPoint = (cardID) => {
        return new Promise(async resolve => {
            // console.log('Card ID: ', cardID);
            NhealthAction.GetLogPoint(cardID)
            .then(res => {
                if(res.isSuccess === true)
                {
                    setPointList(res.log);
                }
                resolve(); 
                // console.log('Get Log Point: ', res);
            })
        })
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    // console.log('Get Member: ', res);
                    if(res.isSuccess === true)
                    {
                        resolve(res.member);
                    }else
                    {
                        if(res.errMessage === 'not found !.')
                        {
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE);
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA);
                            location.reload();
                        }
                    }
                })
            }else
            {
                await useLineLogin(lineConfig.point_history);
            }
        })
    }

    const goToRegisCard = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/welcome-card-register`;
    }

    const getMemberInfoInit = () => {
        return new Promise(async resolve => {
            let memberInfo = !!localStorage.getItem('member_info') ? DecryptedOBJ(localStorage.getItem('member_info')) : null; 
            resolve(memberInfo);
        })
    }

    const getCardInit = (memberInfo) => {
        let cardId = memberInfo["cardid"];
        return new Promise(async resolve => {
            NhealthAction.GetCard(cardId)
            .then(async res => {
                // console.log('Get Card: ', res);
                if(res.isSuccess === true)
                {
                    resolve(res.card.cardid);
                }
            })
        })
    }

    const handleLoader = (status) => {
        if(status === 'active')
        {
            setLoading(true);
        }else
        {
            setLoading(false);
        }
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="cphr-container">
                {/* header */}
                <h1 className="header-text">ประวัติคะแนน</h1>
                {/* point history lists */}
                <div className="p-hist-list">
                    {/* item */}
                    {pointList.length > 0 ? 
                        pointList.map((item, i) => 
                            <div 
                                className="item"
                                key={i}
                            >
                                <span className="date">{item.logDate}</span>
                                {String(item.refRemark).split(',').map(item1 => 
                                    <p className="title t-black">{item1}</p>
                                )}
                                <div className="point-wrap">
                                    <span className="left">คะแนนที่ใช้แลก</span>
                                    <span 
                                        className={`right ${item.earnPoint !== 0 ? 'positive' : ''}${item.burnPoint !== 0 ? 'negative' : ''}`}
                                    >
                                        <span className="p-used">
                                            {item.earnPoint !== 0 && item.earnPoint}
                                            {item.burnPoint !== 0 && item.burnPoint}
                                    </span> คะแนน</span>
                                </div>
                            </div>
                        )
                        :
                        <p className='notfound'>ไม่พบข้อมูล</p>
                    }
                </div>
            </div>
        )
    }
}

export default CardPointHistory